import { Component } from 'react';

import Header from 'components/ui/Header';
import DbList from 'components/dbs/DbList';
import SearchInput from 'components/ui/inputs/SearchInput';
import withAuthorizer from 'components/ui/withAuthorizer';

import { Resources } from 'helpers/ResourceHelper';
import { withTranslation } from 'react-i18next';

class DbsPage extends Component {
  state = {
    search: '',
  };

  onSearch(search) {
    this.setState({ search });
  }

  render() {
    const { t } = this.props;

    return (
      <>
        <Header>
          <div className="d-flex align-items-center justify-content-between">
            <div>
              <h1 className="m-0 p-0 fw-lighter">{t('databases.title')}</h1>
            </div>

            <div>
              <SearchInput id="search-db" placeholder="Pesquisar" onSearch={this.onSearch.bind(this)} />
            </div>
          </div>
        </Header>

        <div className="container mt-4">
          <DbList search={this.state.search} />
        </div>
      </>
    );
  }
}

export default withTranslation()(withAuthorizer(DbsPage, [Resources.DB_MANAGER]));
